(function () {
  var prefetched = new Set();
  var maxPrefetches = 6;
  var hoverTimers = new WeakMap();
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''))) {
    return;
  }

  function isModifiedEvent(event) {
    return event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey);
  }

  function getPrefetchUrl(link) {
    if (!link || link.dataset.noPrefetch !== undefined) return null;
    if (link.target && link.target !== '_self') return null;
    if (link.hasAttribute('download')) return null;

    var rel = link.getAttribute('rel') || '';
    if (/\bnofollow\b/i.test(rel)) return null;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return null;
    if (/^(mailto:|tel:|javascript:|sms:)/i.test(href)) return null;

    try {
      var url = new URL(href, window.location.href);

      if (url.origin !== window.location.origin) return null;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return null;

      var blockedPath = /^\/([a-z]{2}(?:-[a-z]{2})?\/)?(cart[^/]*|checkout[^/]*|account[^/]*|customer_authentication|search[^/]*)(\/|$)/i.test(url.pathname);
      var blockedQuery = /(^|[?&])(add|checkout|payment|customer_posted|contact_type)=/i.test(url.search);
      if (blockedPath || blockedQuery) return null;

      url.hash = '';
      return url.href;
    } catch (error) {
      return null;
    }
  }

  function prefetch(link) {
    var url = getPrefetchUrl(link);

    if (!url || prefetched.has(url) || prefetched.size >= maxPrefetches) return;
    prefetched.add(url);

    var prefetchLink = document.createElement('link');
    prefetchLink.rel = 'prefetch';
    prefetchLink.as = 'document';
    prefetchLink.href = url;
    document.head.appendChild(prefetchLink);
  }

  function findLink(target) {
    return target && target.closest ? target.closest('a[href]') : null;
  }

  document.addEventListener('pointerover', function (event) {
    if (isModifiedEvent(event)) return;

    var link = findLink(event.target);
    if (!link || hoverTimers.has(link)) return;

    hoverTimers.set(link, window.setTimeout(function () {
      hoverTimers.delete(link);
      prefetch(link);
    }, 150));
  }, { passive: true });

  document.addEventListener('pointerout', function (event) {
    var link = findLink(event.target);
    var timer = link && hoverTimers.get(link);

    if (!timer) return;
    window.clearTimeout(timer);
    hoverTimers.delete(link);
  }, { passive: true });

  document.addEventListener('pointerdown', function (event) {
    if (event.button !== 0 || isModifiedEvent(event)) return;
    prefetch(findLink(event.target));
  }, { passive: true });

})();
